import { useTranslation } from 'react-i18next';

import * as St from './SideItemOption.styles';
import useSideItems from './hooks/useSideItems';

import { SideItemType } from '~/core/enums';
import { SideItemInfoModel } from '~/core/models';
import InputOption from '~molecules/InputOption';

type SideItemOptionProps = {
  id: string;
  sideItem: SideItemInfoModel;
  onInfoModalOpen: (isOpen: boolean) => void;
};

const SideItemOption = ({
  id,
  sideItem,
  onInfoModalOpen,
}: SideItemOptionProps): JSX.Element => {
  type ValidType =
    | SideItemType.WALL_SIDE
    | SideItemType.APPLIANCE_SIDE
    | SideItemType.WATERFALL;
  const { t } = useTranslation();
  const { toggleBacksplash, toggleSideOption, updateHeight } = useSideItems();
  const sideItemInput: Record<ValidType, () => JSX.Element | undefined> = {
    [SideItemType.WALL_SIDE]: () => (
      <>
        <InputOption
          type="checkbox"
          isChecked={sideItem?.backsplash?.checked}
          isDisabled={sideItem.disabled}
          value={`${id}.backsplash`}
          label={t('BACKSPLASH.TITLE')}
          onChange={({ target }) => toggleBacksplash(sideItem, target.checked)}
          data-side-type={SideItemType.WALL_SIDE}
        />
        {sideItem.backsplash?.checked && (
          <St.SideItemHeight
            value={sideItem.backsplash.height ?? 0}
            sideItem={sideItem}
            setIsInfoModalOpen={onInfoModalOpen}
            onChange={updateHeight(sideItem)}
          />
        )}
      </>
    ),
    [SideItemType.APPLIANCE_SIDE]: () => undefined,
    [SideItemType.WATERFALL]: () =>
      (sideItem.waterfallHeight ?? 0) > 0 ? (
        <St.SideItemHeight
          value={sideItem.waterfallHeight ?? 0}
          sideItem={sideItem}
          setIsInfoModalOpen={onInfoModalOpen}
          onChange={updateHeight(sideItem)}
        />
      ) : undefined,
  };

  const renderInput =
    sideItem.sideType in sideItemInput
      ? sideItemInput[sideItem.sideType as ValidType]
      : undefined;

  return (
    <St.Container>
      <InputOption
        type="checkbox"
        styleType="radio"
        id={id}
        isChecked={sideItem.checked}
        isDisabled={sideItem.disabled}
        value={sideItem.value}
        label={sideItem.value}
        onChange={(event) =>
          toggleSideOption({ ...sideItem, checked: event.target.checked })
        }
      />

      {sideItem.checked && renderInput?.()}
    </St.Container>
  );
};

export default SideItemOption;
